import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Path} from '../common/path';
import {RestResult} from '../models/response/rest-result';
import {CommonService} from './common.service';
import {SearchRequest} from '../models/request/search-request';
import {ProspectRequest} from '../models/request/prospect/prospect-request';
import {Zone} from '../models/response/address/zone';
import {Constant} from '../common/constant';
import {Street} from '../models/response/address/street';
import {StreetRequest} from '../models/request/address/street-request';

@Injectable()
export class StreetService {

  constructor(protected http: HttpClient,
              protected commonService: CommonService) {
  }

  getOne(streetId: number): Observable<RestResult> {
    return this.http.get<any>(
      Path.API_ENDPOINT +
      Path.STREET +
      Path.STREET_ID.replace(':streetId', streetId.toString()),
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }


  search(request: SearchRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.STREET +
      Path.SEARCH, request,
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  create(request: StreetRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.STREET, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  remove(streetId: number): Observable<RestResult> {
    return this.http.delete<any>(
      Path.API_ENDPOINT +
      Path.STREET +
      Path.STREET_ID.replace(':streetId', streetId.toString()),
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  update(request: ProspectRequest): Observable<RestResult> {
    return this.http.put<any>(
      Path.API_ENDPOINT +
      Path.STREET, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  updateList(requests: StreetRequest[]): Observable<RestResult> {
    return this.http.put<any>(
      Path.API_ENDPOINT +
      Path.STREET + Path.LIST, requests).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  // ===== support for autocomplete ============
  searchByKeyword(keyword: string, districtId?: number): Observable<Street[]> {
    const searchRequest = new SearchRequest();
    const subCondition = new SearchRequest();
    subCondition.conditions = new Array();
    subCondition.conditions.push(
      {
        left: 'name',
        middle: 'like',
        right: keyword,
      },
    );
    subCondition.conditions.push(
      {
        left: 'code',
        middle: '=',
        right: keyword,
      },
    );
    subCondition.conditionType = Constant.CONDITION_TYPE.OR;
    searchRequest.subConditions = [subCondition];
    searchRequest.conditionType = Constant.CONDITION_TYPE.AND;
    searchRequest.conditions = [];
    if (districtId) {
      searchRequest.conditions.push(
        {
          left: 'districtId',
          middle: '=',
          right: districtId,
        },
      );
    }
    searchRequest.offset = 0;
    searchRequest.limit = 10;
    return this.search(searchRequest).pipe(
      map(result => result.data),
    );
  }

  getByName(streetRequest: StreetRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.STREET +
      Path.NAME, streetRequest)
    .pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }
}
